import { message } from "antd";
import { isAxiosError } from "axios";
import React from "react";
import { AppButton } from "../../atoms/Button";
import { useRequestBankDetails } from "./api";

type RequestBankDetailButtonProps = {
  tenantId?: string;
  hasBankDetails?: boolean;
  isLoadingBankDetails?: boolean;
};

export const RequestBankDetailButton = (props: RequestBankDetailButtonProps) => {
  const { tenantId, hasBankDetails, isLoadingBankDetails } = props;

  const { requestBankDetails, isPending } = useRequestBankDetails({
    onError: (error) => {
      if (isAxiosError(error)) message.error(error.response?.data?.error);
    },
  });

  if (isLoadingBankDetails || hasBankDetails) return null;

  const handleClick = () => {
    if (!tenantId) return;
    requestBankDetails(tenantId);
  };

  return (
    <AppButton loading={isPending} onClick={handleClick}>
      Request Details
    </AppButton>
  );
};
